import React from 'react';
import { Gauge as MuiGauge, gaugeClasses } from '@mui/x-charts/Gauge';

type GaugeSize = 'sm' | 'md' | 'lg';

interface GaugeProps {
  value: number;
  valueMin?: number;
  valueMax?: number;
  startAngle?: number;
  endAngle?: number;
  width?: number;
  height?: number;
  size?: GaugeSize;
  showLabel?: boolean;
  label?: string;
  subtitle?: string;
}

const getSizeFromString = (size?: GaugeSize): { width: number; height: number } => {
  switch (size) {
    case 'sm':
      return { width: 120, height: 120 };
    case 'lg':
      return { width: 260, height: 260 };
    case 'md':
    default:
      return { width: 180, height: 180 };
  }
};

const Gauge: React.FC<GaugeProps> = ({
  value,
  valueMin = 0,
  valueMax = 100,
  startAngle = -110,
  endAngle = 110,
  width: propWidth,
  height: propHeight,
  size = 'md',
  showLabel = true,
  label = '',
  subtitle = '',
}) => {
  const sizeDefaults = getSizeFromString(size);
  const width = propWidth ?? sizeDefaults.width;
  const height = propHeight ?? sizeDefaults.height;

  return (
    <div className="flex flex-col items-center">
      <MuiGauge
        value={value}
        valueMin={valueMin}
        valueMax={valueMax}
        startAngle={startAngle}
        endAngle={endAngle}
        width={width}
        height={height}
        sx={{
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: width / 5,
            transform: 'translate(0px, 0px)',
          },
        }}
        text={({ value }) => value !== null ? `${Math.round(value)}` : '0'}
      />
      
      {showLabel && label && (
        <div className="text-center mt-2">
          <div className="text-sm font-medium text-gray-700">{label}</div>
          {subtitle && <div className="text-xs text-gray-500 mt-0.5">{subtitle}</div>}
        </div>
      )}
    </div>
  );
};

// Export the Gauge component as default for use in the application
export default Gauge;

// Named export for alternative import style
export { Gauge as UtilizationGauge };